import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import MobileStepper from '@material-ui/core/MobileStepper';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import RelatedIrwinRecord from './RelatedIrwinRecord';
import RelatedBulkUploadRecord from './RelatedBulkUploadRecord';
import RelatedWFMIRecord from './RelatedWFMIRecord';
import RelatedFireStatRecord from './RelatedFireStatRecord';
import RelatedFMISRecord from './RelatedFMISRecord';
import RelatedFODRecord from './RelatedFODRecord';
import RelatedCertificationRecord from './RelatedCertificationRecord';

import theme from '../../../muiTheme';

const styles = {
  errorDialogContent: {
    width: "500px"
  },
  errorDialogTitle: {
    color: theme.palette.accent1Color
  }
}

class RelatedRecordsDialog extends Component {

  constructor (props)
  {
    super(props);
    this.state =
    {
      currentIndex: 0,
      hasData: false,
      incidentCount: 0,
      relatedRecords:[]
    };

  }

  handleBack = () =>
  {
    const previousVal = this.state.currentIndex - 1;
    this.setState({
      currentIndex: previousVal
    });
  }

  handleNext = () =>
  {
    const nextVal = this.state.currentIndex + 1;
    this.setState({
      currentIndex: nextVal
    });
  }
  getDisplayContent = () =>
  {
    const currentRecord = this.state.relatedRecords[this.state.currentIndex];
    if (currentRecord.hasOwnProperty("IrwinID") && !currentRecord.hasOwnProperty("FireStatID"))  //TODO: Get rid of hardcodes
    { 
        return this.getIrwinPanel(currentRecord, this.state.irwinDeltas);
    }

    if (currentRecord.hasOwnProperty("CertificationRecordID"))  //TODO: Get rid of hardcodes
    { 
        return this.getCertificationPanel(currentRecord);
    }

    if (currentRecord.hasOwnProperty("WFMIID"))  //TODO: Get rid of hardcodes
    {
        return this.getWFMIPanel(currentRecord);
    }

    if (currentRecord.hasOwnProperty("BulkUploadID"))  //TODO: Get rid of hardcodes
    {
        return this.getBulkUploadPanel(currentRecord);
    }

    if (currentRecord.hasOwnProperty("FireStatID"))  //TODO: Get rid of hardcodes
    {
        return this.getFireStatPanel(currentRecord);
    }

    
    if (currentRecord.hasOwnProperty("FMISID"))  //TODO: Get rid of hardcodes
    {
        return this.getFMISPanel(currentRecord);
    }
    //
    if (currentRecord.hasOwnProperty("FODID"))  //TODO: Get rid of hardcodes
    {
        return this.getFODPanel(currentRecord);
    }
  }

  getIrwinPanel = (dataRecord, attributeDeltas) =>
  {
    return (<RelatedIrwinRecord record={dataRecord} AttributeDeltas={attributeDeltas}/>)
  }

  getCertificationPanel = (dataRecord, attributeDeltas) =>
  {
    return (<RelatedCertificationRecord record={dataRecord}/>)
  }

  getWFMIPanel = (dataRecord) =>
  {
    return (<RelatedWFMIRecord record={dataRecord}/>)
  }

  getBulkUploadPanel = (dataRecord) =>
  {
  return (<RelatedBulkUploadRecord record={dataRecord}/>)
  }

  getFireStatPanel = (dataRecord) =>
  {
      return (<RelatedFireStatRecord record={dataRecord}/>)
  }

  getFMISPanel = (dataRecord) =>
  {
      return (<RelatedFMISRecord record={dataRecord}/>)
  }

  getFODPanel = (dataRecord) =>
  {
      return (<RelatedFODRecord record={dataRecord}/>)
  }

  componentDidUpdate(prevProps)
  {
    const hasData = (this.props.relatedRecords);

    if (hasData !== this.state.hasData)
    {
      this.setState({
        hasData: hasData
      });
    }

    if (hasData && this.props.relatedRecords !== prevProps.relatedRecords)
    {
      const numFireStatIncidents = this.props.relatedRecords.FireStatIncidents.length;
      const numIrwinIncidents = this.props.relatedRecords.IrwinIncidents.length;
      const numBulkUploadIncidents = this.props.relatedRecords.BulkUploadIncidents.length;
      const numWFMIIncidents = this.props.relatedRecords.WFMIIncidents.length;
      const numFMISIncidents = this.props.relatedRecords.FMISIncidents.length;
      const numFODIncidents = this.props.relatedRecords.FODIncidents.length;
      const numCertificationRecords = this.props.relatedRecords.CertificationRecords.length;

      const totalIncidentCount = (numIrwinIncidents + numBulkUploadIncidents + numFMISIncidents + numWFMIIncidents + numFireStatIncidents + numFODIncidents + numCertificationRecords);

      let recordsArray = [];
      for (var i = 0; i < this.props.relatedRecords.IrwinIncidents.length; i++)
      {
        recordsArray.push(this.props.relatedRecords.IrwinIncidents[i]);
      }

      for (var j = 0; j < this.props.relatedRecords.BulkUploadIncidents.length; j++)
      {
        recordsArray.push(this.props.relatedRecords.BulkUploadIncidents[j]);
      }

      for (var k = 0; k < this.props.relatedRecords.WFMIIncidents.length; k++)
      {
        recordsArray.push(this.props.relatedRecords.WFMIIncidents[k]);
      }

      for (var l = 0; l < this.props.relatedRecords.FireStatIncidents.length; l++)
      {
        recordsArray.push(this.props.relatedRecords.FireStatIncidents[l]);
      }

      for (var m = 0; m < this.props.relatedRecords.FODIncidents.length; m++)
      {
        recordsArray.push(this.props.relatedRecords.FODIncidents[m]);
      }

      
      for (var q = 0; q < this.props.relatedRecords.FMISIncidents.length; q++)
      {
        recordsArray.push(this.props.relatedRecords.FMISIncidents[q]);
      }

      for (var s = 0; s < this.props.relatedRecords.CertificationRecords.length; s++)
      {
        recordsArray.push(this.props.relatedRecords.CertificationRecords[s]);
      }

      this.setState({
        incidentCount: totalIncidentCount,
        relatedRecords: recordsArray,
        irwinDeltas: this.props.relatedRecords.IrwinDeltas
      });
    }
  }

  render()
  {
    let panelContent = (this.state.hasData) ? ( this.getDisplayContent() ) : ("");

    let stepperContent = (this.state.hasData) ?
    (
      <MobileStepper
        steps={this.state.incidentCount}
        position="static"
        variant="text"
        activeStep={this.state.currentIndex}
        nextButton={
          <Button size="small" onClick={this.handleNext} disabled={this.state.currentIndex === this.state.incidentCount - 1}>
            Next
            {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
          </Button>
        }
        backButton={
          <Button size="small" onClick={this.handleBack} disabled={this.state.currentIndex === 0}>
            {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            Back
          </Button>
        }
      />
    )
    :
    (
      <CircularProgress color="secondary" size={110} className="loading-spinner-center-notransform" />
    );

  return (
    <Dialog
     title="Related Records"
     modal={true}
     contentStyle={{minWidth: '40%'}}
     open={this.props.open}
     autoScrollBodyContent={true}
     titleStyle={styles.errorDialogTitle}>
     <div style={{ minHeight: 400 }}>
        {panelContent}
        {stepperContent}
      </div>
     <DialogActions>
      <Button onClick={this.props.onRequestClose} color="primary">
        Close
      </Button>
    </DialogActions>
   </Dialog>
 )

  }
}

export default RelatedRecordsDialog;
